/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiStorageLocation, LockElement, LockedContextDto } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of StorageLocationsController.
 */
export class StorageLocationsRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /storage_locations:prefill
     */
    public createPrefilled(): Promise<Result<ApiStorageLocation>> {
        return this.http.post<Result<ApiStorageLocation>, undefined>('/storage_locations:prefill', undefined);
    }

    /**
     * Calls GET /storage_locations:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiStorageLocation>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiStorageLocation>>>('/storage_locations:query', query);
    }

    /**
     * Calls POST /storage_locations:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiStorageLocation>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiStorageLocation>>, ListRequest>('/storage_locations:query', listRequest, query);
    }

    /**
     * Calls POST /storage_locations/{primaryId}/start_edit_mode
     */
    public startEditMode(primaryId: string): Promise<Result<LockedContextDto<ApiStorageLocation>>> {
        return this.http.post<Result<LockedContextDto<ApiStorageLocation>>, undefined>(`/storage_locations/${primaryId}/start_edit_mode`, undefined);
    }

    /**
     * Calls POST /storage_locations/{draftId}/commit
     */
    public commitDraft(draftId: string): Promise<Result<ApiStorageLocation>> {
        return this.http.post<Result<ApiStorageLocation>, undefined>(`/storage_locations/${draftId}/commit`, undefined);
    }

    /**
     * Calls POST /storage_locations/locks
     */
    public lockAll(ids: string[]): Promise<Result<ApiStorageLocation[]>> {
        return this.http.post<Result<ApiStorageLocation[]>, string[]>('/storage_locations/locks', ids);
    }

    /**
     * Calls POST /storage_locations/{primaryId}/locks
     */
    public lock(primaryId: string): Promise<Result<LockElement>> {
        return this.http.post<Result<LockElement>, undefined>(`/storage_locations/${primaryId}/locks`, undefined);
    }

    /**
     * Calls DELETE /storage_locations/{primaryId}/locks
     */
    public unlock(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/storage_locations/${primaryId}/locks`);
    }

    /**
     * Calls GET /storage_locations/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiStorageLocation>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiStorageLocation>>(`/storage_locations/${primaryId}`, query);
    }

    /**
     * Calls POST /storage_locations
     */
    public add(dto: ApiStorageLocation): Promise<Result<ApiStorageLocation>> {
        return this.http.post<Result<ApiStorageLocation>, ApiStorageLocation>('/storage_locations', dto);
    }

    /**
     * Calls PUT /storage_locations/{primaryId}
     */
    public update(dto: ApiStorageLocation, primaryId: string): Promise<Result<ApiStorageLocation>> {
        return this.http.put<Result<ApiStorageLocation>, ApiStorageLocation>(`/storage_locations/${primaryId}`, dto);
    }

    /**
     * Calls PATCH /storage_locations
     */
    public putRange(dtos: ApiStorageLocation[]): Promise<Result<ApiStorageLocation[]>> {
        return this.http.patch<Result<ApiStorageLocation[]>, ApiStorageLocation[]>('/storage_locations', dtos);
    }

    /**
     * Calls DELETE /storage_locations/{primaryId}
     */
    public delete(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/storage_locations/${primaryId}`);
    }

    /**
     * Calls POST /storagelocations:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiStorageLocation>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiStorageLocation>>, ListRequestWithIds>('/storagelocations:batch', listRequest, query);
    }
}
